import { Component, OnInit, Output,Input,EventEmitter } from '@angular/core';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ReportMetadata ,Approver, ReportSchedule} from '../../models/report.model';
import { environment } from '../../../environments/environment';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { LookupService } from '../../services/lookups/lookup.service';
import { NotifierService } from 'angular-notifier';
import { User } from '../../models/user.model';



@Component({
  selector: 'app-requiredrptmetadata',
  templateUrl: './requiredrptmetadata.component.html',
  styleUrls: ['./requiredrptmetadata.component.css']
})
export class RequiredrptmetadataComponent implements OnInit 
{
  showLaunchButtonClick: boolean = false;
  reportScheduleforStatus: ReportSchedule;
  saveReportMetadatafields: any;
  reportMetadata: ReportMetadata;
  saveStatus:boolean = false; 
  launchStatus: boolean = false;
  controlDisabled:boolean = false;
  accessLink :string;
  //selectedApprover :Approver;
  //ApproverList : Approver[];
  ApproversList:User[]=[];
  selectedApprover:User;
  selectedReportID: string = '';
  currentUser: User;

  @Output() showHideMetadata= new EventEmitter<boolean>();
  @Input() reportId:any;
  constructor(private reportService: ReportdashboardService,
              private lookupService:LookupService,
              private authUserService:AuthUserService,
              private authUser: AuthUserService,
              private notifier: NotifierService
              ) { 
    
  }
 
  ngOnInit() {
       this.currentUser = this.authUser._user;
      // console.log("User Role Details=================" + JSON.stringify(this.currentUser.userRoles[1].roleName));
  }
  SaveReportMetadata() {
    this.saveReportMetadatafields = {id: this.reportMetadata.id, 
                                     approverId: this.selectedApprover.id, 
                                     highlights: this.reportMetadata.highlights,
                                     preferredReportName: this.reportMetadata.reportName,
                                     preparedBy:this.reportMetadata.preparedBy
                                    };
    //console.log(this.saveReportMetadatafields);

    this.reportService.saveReportMetadata(this.saveReportMetadatafields).subscribe(
      (resp) => {
        if (resp.ok) {
          this.notifier.notify('success','Required Report saved successfully');
          this.launchStatus = true;
          // SUCCESSFULLY ADDED
         // alert("Saved Successfully");
          //console.log(resp);
        }
        else
        {
          this.notifier.notify('error','Something went wrong, Please contact System Administrator');
        }
      });



  }
  onApproverChange(approver: Approver) {
    this.reportMetadata.approverId = approver.id;
    if (approver.id != null) {
      this.saveStatus = true;
    }
    else
    {
      this.saveStatus = false;
    }

    // console.log("save Status" + this.saveStatus);
  }
 
  LaunchReport(Id:any)
  {

    //  console.log("User Role Details=================" + JSON.stringify(this.currentUser.userRoles[1].roleName));

     this.reportService.getReportScheduleById(Id).subscribe((metadata:ReportSchedule)=>{
          this.reportScheduleforStatus = metadata;
          // console.log("REport Status=========" + JSON.stringify(this.reportScheduleforStatus));
          this.reportService.launchReport(Id).subscribe(
        (data) => {
          
          if (this.reportScheduleforStatus.reportState == 'Approved And Sent To Washington' || this.reportScheduleforStatus.reportState == 'Hold')
            {
              if (this.currentUser.userRoles[1].roleName == 'Admin'){ 
                this.accessLink ="ms-word:ofe|u|"+ environment.serverUrl+"/"+ data; }
              else{
                this.accessLink = environment.serverUrl+"/"+ data; }
            }
            else
            { this.accessLink ="ms-word:ofe|u|"+ environment.serverUrl+"/"+ data; }
            const link = document.createElement('a');
            link.href = this.accessLink;
            link.setAttribute('visibility', 'hidden');
            link.click();
            //TODO: The above code is not working for IE but works for Chorme
            //window.open(this.accessLink);
    
        });
      });
    
      //console.log(this.accessLink);
    
  }
  CancelReportMetadataDialog()
  {
    //console.log("CancelReportMetadataDialog");
    this.showHideMetadata.emit(false);
  }

  showMetadataDialog(reportId:any)
  {
      this.saveStatus = false;
      this.launchStatus = false;
      this.reportService.getReportScheduleById(reportId).subscribe((metadata:ReportMetadata)=>{
      //console.log(metadata);
      this.reportMetadata = metadata;
      //this.reportMetadata.preparedBy =this.authUserService._user.firstName +" , " +this.authUserService._user.lastName ;
      this.reportMetadata.preparedBy=this.reportMetadata.preparedBy;
      if(this.reportMetadata.reportNumber == null)
      {
        this.reportMetadata.reportNumber ="(Auto Generated)";
        this.reportMetadata.preparedBy =this.authUserService._user.firstName +" " +this.authUserService._user.lastName ;
        // this.launchStatus = false;
      }
      else
      {
        this.launchStatus = true;
      }
      //this.reportMetadata.reportType ="Required Report - Public Distribution"; 
          
      if(this.reportMetadata.approverId!==0)
      {        
        this.saveStatus = true;
      }
      
      if(this.reportMetadata.isReportLocked === true)
      {
        this.controlDisabled = true;
        this.saveStatus = false;
      }
      else 
      {
        this.controlDisabled = false;
        //this.saveStatus = true;
      }
      
      

    
      this.lookupService.getAllActiveUsers$().subscribe((data)=>{
        this.selectedApprover = data.map(u=>u).filter(u=> u.id=== this.reportMetadata.approverId)[0];
        
        //console.log(this.ApproverNamesList);
      });
     // this.lookupService.getPostApprovers(this.reportMetadata.fasPostId).subscribe((approvers:[Approver]) =>{
      //this.ApproverList = approvers; 
      //this.selectedApprover = approvers.find(approver => approver.id === this.reportMetadata.approverId)
     //});
     


    });
    this.showHideMetadata.emit(true);
  }
  filterNames(event)
  {
    //console.log(event);
    var searchString:string = event.query;
    this.lookupService.getAllActiveUsers$().subscribe((data)=>{
      this.ApproversList = data.map(u=>u).filter(u=> u.fullName.toLowerCase().includes(searchString.toLowerCase()));
      //console.log(this.ApproverNamesList);
      this.ApproversList.sort((a,b):number=>{
        if (a.fullName < b.fullName) return -1;
        if (a.fullName > b.fullName) return 1;
        return 0;
      });
    });
  }

  //  OnLaunchReportAlertClassified(id: any)
  // {
  //   this.showLaunchButtonClick = true;
  //   this.selectedReportID = id;
  // }

  // OnClassifiedOkButton()
  // {
  //   this.showLaunchButtonClick = false;
  //   this.LaunchReport(this.selectedReportID);
  // }

}
